module.exports = __webpack_public_path__ + "static/media/DSC_2174_HDR.bcdf6196.jpg";